const formatChangedPayload = (payload: Record<string, any>): string => {
  if (!payload || Object.keys(payload).length === 0) {
    return '';
  }
  const chainOfChanges = Object.entries(payload)
    .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
    .join(', ');

  return `{ ${chainOfChanges} }`;
};

export default formatChangedPayload;
